import {enqueueSnackbar} from 'notistack';
import {useEffect} from 'react';

import {useAppSelector} from '../../hooks/redux';
import {backendSelectors} from '../../redux/app/selectors';
import {CloseSnackbarAction} from '../common/CloseSnackbarButton';
import SnackbarMessages from '../common/SnackbarMessages';

export const BackendMessages = () => {
  const messages = useAppSelector(backendSelectors.getMessages);

  useEffect(() => {
    if (messages?.length) {
      messages.forEach((el) => {
        enqueueSnackbar(<SnackbarMessages messages={[el.message]} />, {
          variant: el.type,
          action: CloseSnackbarAction,
        });
      });
    }
  }, [messages]);

  return null;
};
